import utils from '../../../../modules/utils';
import API from '../../../api/api';

function isTokenReceived(status) {
  return status === 'HOSTED_PAYMENT_TOKEN_RECEIVED';
}

function isReturningFromHostedPage() {
  return window.start.selectedPaymentMethod === 'SPLITIT';
}

function isProblemWithService(status) {
  return (status === 'HOSTED_PAYMENT_AUTHENTICATION_FAILED'
    || status === 'HOSTED_PAYMENT_CURRENTLY_UNAVAILABLE');
}

function returnedFromHostedPage(queryParams) {
  const {state} = utils.fn.getURIParams(queryParams);
  
  return API.doAPIRequest(`/v2/return-from-hosted/splitit?status=${state}`, JSON.stringify({}));
}

export default {
  isTokenReceived, isProblemWithService, isReturningFromHostedPage, returnedFromHostedPage,
};
